import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of, retry, throwError, timer } from 'rxjs';
import { AuthService } from './auth.service';

// Un 429 (límite de peticiones), un corte de red o un 5xx no significan que la sesión venció:
// se reintenta antes de mandar al login.
const reintentable = (e: unknown) =>
  e instanceof HttpErrorResponse && (e.status === 0 || e.status === 429 || e.status >= 500);

// El login vive en otro subdominio (unilogin): sin sesión válida se sale de la app.
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);

  return auth.entrarAlModulo().pipe(
    retry({ count: 2, delay: (e) => (reintentable(e) ? timer(1000) : throwError(() => e)) }),
    map(() => true),
    catchError(() => {
      auth.irAlLogin();
      return of(false);
    }),
  );
};
